import { render, staticRenderFns } from "./IconsList.vue?vue&type=template&id=5bf7153a&scoped=true"
import script from "./IconsList.vue?vue&type=script&lang=js"
export * from "./IconsList.vue?vue&type=script&lang=js"
import style0 from "./IconsList.vue?vue&type=style&index=0&id=5bf7153a&prod&scoped=true&lang=css"
import style1 from "./IconsList.vue?vue&type=style&index=1&id=5bf7153a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf7153a",
  null
  
)

export default component.exports